import {
  PowertrainSpecsSection,
  PowertrainSpecsSectionProps,
} from '@rimactechnology/rimac-ui-lib';

import {
  CardsSectionFragment,
  FooterQuery,
  FormQuery,
  HeroVideoSectionFragment,
  NavigationQuery,
  PartnersBlogSectionFragment,
  PowertrainSpecsFragment,
  ProductSpecsBlockFragment,
  SeoFragment,
} from '@/api';
import { Layout } from '@/components/layout/Layout';
import { Partners } from '@/components/partners/Partners';
import { Seo } from '@/components/Seo';
import EnhancedProductSpecsBlock from '@/components/shared/EnhancedProductSpecsBlock';
import HeroVideoSection from '@/components/shared/HeroVideoSection';
import IconCards from '@/components/shared/IconCards';
import getCdlPublicId from '@/hooks/useCdlPublicId';

type Props = {
  seo?: SeoFragment | null;
  hero?: HeroVideoSectionFragment | null;
  cards?: CardsSectionFragment | null;
  powertrainSpecs?: PowertrainSpecsFragment | null;
  productSpecsBlocks?: ProductSpecsBlockFragment[] | null;
  partnersBlogSection?: PartnersBlogSectionFragment | null;
  formData: FormQuery;
  footerData: FooterQuery;
  headerData: NavigationQuery;
};

export const PowertrainPage = ({
  seo,
  hero,
  cards,
  powertrainSpecs,
  productSpecsBlocks,
  formData,
  footerData,
  headerData,
  partnersBlogSection,
}: Props) => {
  const powertrainSpecsProps: PowertrainSpecsSectionProps = {
    anchor: powertrainSpecs?.anchor || undefined,
    image: {
      imgSrc: getCdlPublicId(
        powertrainSpecs?.image?.img_desktop.data?.attributes?.url || '',
      ),
      imgSrcMobile: getCdlPublicId(
        powertrainSpecs?.image?.img_mobile?.data?.attributes?.url || undefined,
      ),
      alt: powertrainSpecs?.image?.alt || '',
    },
    title: powertrainSpecs?.title || '',
    subtitle: powertrainSpecs?.description || '',
    paragraphs: (powertrainSpecs?.paragraphs || []).map(
      (paragraph) => paragraph?.paragraphs || '',
    ),
    tableRows: (powertrainSpecs?.specTables?.data || []).map((table) => ({
      label: table.attributes?.title || '',
      specs: (table?.attributes?.specs || []).map((spec) => ({
        label: spec?.label || '',
        value: spec?.value || '',
      })),
    })),
  };

  return (
    <Layout formData={formData} footerData={footerData} headerData={headerData}>
      <Seo seo={seo} />
      <HeroVideoSection hero={hero} titleMaxWidth={840} />
      <IconCards cards={cards} />
      <PowertrainSpecsSection {...powertrainSpecsProps} />
      {productSpecsBlocks?.map((block, index) => (
        <EnhancedProductSpecsBlock
          key={`enhancedProductSpecsBlock-powertrain-item-${index}`}
          productSpecsBlock={block}
          titleMaxWidth={index === 1 ? 400 : 1000}
          parentIndex={index}
        />
      ))}
      <Partners data={partnersBlogSection} />
    </Layout>
  );
};
